export var actionTypePrefix = '@@watch';
export var reduxKey = '@@watch';
//# sourceMappingURL=constants.js.map